import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { HomeSignal } from '../../../Interfaces/home-signal.interface';

@Component({
  selector: 'app-home-signal-row',
  standalone: true,
  imports: [COMMON_IMPORTS],
  templateUrl: './home-signal-row.component.html',
  styleUrl: './home-signal-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeSignalRowComponent {
  readonly entry = input.required<HomeSignal>();
}
